import React from 'react';
import { shape, arrayOf, string, func, number } from 'prop-types';

import RadioGroup from '../RadioGroup';
import Dropdown from '../Dropdown';

import styles from './ContractPeriodSelector.scss';

function ContractPeriodSelector({ options, value, onChange }) {
  return (
    <div className={styles.root} data-show-radio={options.length <= 3}>
      <RadioGroup
        options={options}
        value={value}
        onChange={onChange}
        className={styles.radioGroup}
      />
      <Dropdown
        options={options}
        value={value}
        onChange={onChange}
        className={styles.dropdown}
      />
    </div>
  );
}

ContractPeriodSelector.propTypes = {
  value: number.isRequired,
  onChange: func.isRequired,
  className: string,
  options: arrayOf(
    shape({
      value: number.isRequired,
      label: string.isRequired,
    })
  ),
};

export default ContractPeriodSelector;



// WEBPACK FOOTER //
// ./app/containers/Premium/components/SubscriptionSection/components/ContractPeriodSelector/ContractPeriodSelector.jsx